import React, { useState } from 'react'
import s from './SalonFilterPage.module.scss'
const PriceRange = () => {
    const [priceRange, setPriceRange] = useState(50);
    return (
        <div className={s.price_range_slider}>
            <div className={s.price_range_slider_container}>
                <span className={s.price_range_slider_container_value}>$10</span>
                <input
                    type="range"
                    min="10"
                    max="100"
                    value={priceRange}
                    onInput={(e) => {
                        //@ts-ignore
                        const value = e.target.value;
                        //@ts-ignore
                        e.target.style.setProperty('--value', value);
                        setPriceRange(value);
                    }}
                    className={s.price_range_slider_container_slider}
                />
                <span className={s.price_range_slider_container_value}>$100</span>
            </div>
        </div>
    )
}

export default PriceRange